/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ca-avatar[_ngcontent-%COMP%]{width:55px;height:55px;display:block}table[_ngcontent-%COMP%]{width:100%;border:0;border-spacing:0}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{margin:0}table[_ngcontent-%COMP%]   td.number[_ngcontent-%COMP%]{text-align:center}table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]:first-of-type{text-align:left}table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(odd){background-color:#fff}"];
export { styles as styles };
